import { useRecoilState, useResetRecoilState } from "recoil";
import _ from "lodash";
import { myTimesheetFilterState } from "my-timesheet/states";

export const useMyTimesheetFilterState = () => {
  const [filter, setFilter] = useRecoilState(
    myTimesheetFilterState("my-sheet-filter"),
  );
  const resetState = useResetRecoilState(
    myTimesheetFilterState("my-sheet-filter"),
  );

  const [prevFilter, setPrevFilter] = useRecoilState(
    myTimesheetFilterState("my-sheet-filter-prev"),
  );
  const resetPrvFilterState = useResetRecoilState(
    myTimesheetFilterState("my-sheet-filter-prev"),
  );

  const handleResetState = () => {
    resetState();
    resetPrvFilterState();
  };

  const handleFilterChange = (state: typeof filter) => {
    setPrevFilter(_.cloneDeep(filter));
    setFilter(state);
  };

  const isChanged = !_.isEqual(filter, prevFilter);

  let isTouched = false;
  if (
    filter?.client?.length !== 0 ||
    filter?.project?.length !== 0 ||
    filter?.cost?.length !== 0
  ) {
    isTouched = true;
  }

  return {
    state: filter,
    setState: handleFilterChange,
    resetState: handleResetState,
    isTouched: isTouched,
    isChanged: isChanged,
  };
};

export default useMyTimesheetFilterState;
